<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <ValidationProvider name="nombre" rules="required" v-slot="{ errors }"
          :custom-messages="{ required: 'El nombre es obligatorio' }">
          <base-input type="text" label="Nombre(s)" placeholder="Nombre(s)" v-model="currentAccionista.nombre">
          </base-input>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="col-md-4">
        <ValidationProvider name="paterno" rules="required" v-slot="{ errors }" :custom-messages="{
          required: 'El apellido paterno es obligatorio'
        }">
          <base-input type="text" label="Apellido Paterno" placeholder="Apellido Paterno"
            v-model="currentAccionista.paterno">
          </base-input>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="col-md-4">
        <base-input type="text" label="Apellido Materno" placeholder="Apellido Materno"
          v-model="currentAccionista.materno">
        </base-input>
      </div>
    </div>

    <div class="row">
      <!-- v-if="complete" -->
    </div>

    <div class="row">
      <div class="col-md-4">
        <!-- |length:13 pq puede ser 12-->
        <ValidationProvider name="rfc" rules="required|length:13" v-slot="{ errors }" :custom-messages="{
          required: 'El RFC es obligatorio',
          length: 'Debe tener 13 caracteres'
        }">
          <base-input type="text" label="RFC" placeholder="RFC" v-model="currentAccionista.rfc">
          </base-input>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="col-md-4">
        <ValidationProvider name="porcentaje" rules="required" v-slot="{ errors }"
          :custom-messages="{ required: 'El porcentaje es obligatorio' }">
          <base-input type="number" label="Porcentaje" placeholder="Porcentaje" v-model="currentAccionista.porcentaje">
          </base-input>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="col-md-4">
        <ValidationProvider name="monto" rules="required" v-slot="{ errors }" :custom-messages="{
          required: 'El monto es obligatorio'
        }">
          <base-input type="number" label="Monto" placeholder="Monto" v-model="currentAccionista.monto">
          </base-input>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

    <div class="text-center">
      <button type="submit" class="btn btn-fill float-right orange-btn">
        Guardar
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalAccionista",

  props: {
    currentAccionista: { type: Object },
    complete: { type: Boolean }
  },

  watch: {
    "currentAccionista.rfc": function (value) {
      if (!value) {
        this.currentAccionista.rfc = "";

        return;
      }

      this.currentAccionista.rfc = this.currentAccionista.rfc.toUpperCase();
    },
  },
};
</script>
